import * as React from 'react'

import { BackgroundToLightnessProvider, Button } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import type { Back, Background } from 'modules/core/components/Card/types'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  inverted?: boolean
  back?: Back | (() => void)
  left?: React.ReactNode
  middle?: React.ReactNode
  right?: React.ReactNode
  background?: Background
  fancy?: boolean
}

const CardHeader: React.FC<React.PropsWithChildren<Props>> = observer(
  ({ children, left, middle, right, inverted, fancy, back, background }) => {
    const renderBack = React.useCallback(() => {
      if (!back) return null
      if (typeof back === 'function') {
        return <Button onClick={back} type="primary" iconName="arrow-left" />
      }

      return (
        <Button.Router
          aria-label={back?.label}
          to={back?.href}
          type="primary"
          iconName="arrow-left"
        />
      )
    }, [back])

    const overlayStyle = React.useMemo((): Record<string, unknown> => {
      if (!background) return {}

      return {
        backgroundColor: background.color,
        opacity: background.url ? 0.5 : 1,
      }
    }, [background])

    const headerStyle = React.useMemo((): Record<string, any> => {
      if (!background) return {}

      return {
        background: `url(${background.url})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }
    }, [background])

    const ifFancy = Boolean(fancy)

    return (
      // FIXME: this is temporary till new Card is created
      <BackgroundToLightnessProvider background="grey000White">
        <div
          style={headerStyle}
          className={cx('header', {
            inverted,
            fancy,
          })}
        >
          {ifFancy && <div className={styles.overlay} style={overlayStyle} />}
          <div className={styles.left}>
            {renderBack()}
            {left}
          </div>
          <div className={styles.middle}>{middle}</div>
          <div className={styles.right}>{right}</div>

          <div className={styles.content}>{children}</div>
        </div>
      </BackgroundToLightnessProvider>
    )
  }
)

export default CardHeader
